import { SafeAreaContent } from "@/components/content/safe-area-content";
import { cn } from "@/utils/cn";
import { IonPage } from "@ionic/react";
import { memo, ReactNode, RefObject } from "react";

interface ProfilePageContainerProps {
  pageRef?: RefObject<HTMLElement | null>;
  children: ReactNode;
  className?: string;
  backgroundColor?: string;
  onSettingButtonClick?: () => void;
}

export const ProfilePageContainer = memo(function ProfilePageContainer({
  children,
  className,
  pageRef,
  backgroundColor,
  onSettingButtonClick,
}: ProfilePageContainerProps) {
  const resolvedBackground = backgroundColor ?? "var(--color-grey-100)";

  return (
    <IonPage
      ref={pageRef}
      className="bg-screen-gray"
      style={{
        backgroundColor: resolvedBackground,
      }}
    >
      <SafeAreaContent fullscreen className="relative">
        <div
          className={cn(
            "relative z-10",
            "no-scrollbar h-full overflow-y-auto",
            "pb-[calc(var(--safe-area-inset-bottom)+6.5rem)]",
            "pt-[calc(var(--safe-area-inset-top)+4rem)]",
          )}
          data-scroll-container
        >
          <div
            className={cn(
              "mx-auto flex max-w-[450px] flex-col items-center justify-start gap-4 self-center",
              className,
            )}
          >
            {children}
          </div>
        </div>
      </SafeAreaContent>
    </IonPage>
  );
});
